import { baseURL } from "../../util/Constant";
import { getMessage } from "../redux/messageSlice";
import { getAllStorage, loadStorage } from "../redux/storageSlice";
import { getNewStatusFetch } from "./fetchStatus";

//Get New Status
export const getAllStorageFetch = () => (dispatch) => {
  dispatch(loadStorage(false));
  fetch(`${baseURL}/storage/getAll`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return
      }
      dispatch(getAllStorage(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const setTableCheckTrueFetch = (orderSH, rowIndex) => (dispatch) => {
  dispatch(loadStorage(false));
  fetch(`${baseURL}/storage/setTableCheckTrue`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderSH, rowIndex }),
  })
    .then((res) => res.json())
    .then(() => {
      dispatch(getNewStatusFetch());
    })
    .catch((error) => {
      console.log(error);
    });
};


export const storageFinishFetch = (orderSO, number, line) => (dispatch) => {
  dispatch(loadStorage(false));
  fetch(`${baseURL}/storage/storageFinish`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderSO, number, line }),
  })
    .then((res) => res.json())
    .then(() => {
      dispatch(getAllStorageFetch());
    })
    .catch((error) => {
      console.log(error);
    });
};

export const storegeEntStatusFetch = (id) => (dispatch) => {
  dispatch(loadStorage(false));
  fetch(`${baseURL}/storage/storegeEntStatus`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then(() => {
      dispatch(getAllStorageFetch());
    })
    .catch((error) => {
      console.log(error);
    });
};


export const getFalseFinishSHFetch = () => (dispatch) => {
  dispatch(loadStorage(false));
  fetch(`${baseURL}/storage/getFalseFinishSH`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch(getAllStorage(data));
    })
    .catch((error) => {
      console.log(error);
    });
};
